module.exports = __webpack_public_path__ + "static/Заявление_закрытие_вклада_архив-d3343e4090e6d5dafd78204540821093.pdf";